<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h5>
                        <form v-if="category">
                            <div class="row">

                                <div class="col-md-10">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="category.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Активна</option>
                                            <option value="0">Не активна</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="category.sort"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Количество цитат в категории"
                                              v-model="category.count"
                                              placeholder="" readonly>
                                    </fg-input>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!category.sort"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>
                <div class="col-md-4">
                    <card>
                        <h4 slot="header" class="card-title">Локализация</h4>
                        <form v-if="category">
                            <div class="row">

                                <div class="col-md-10">
                                    <div class="content" v-for="(itm,index) in locales" :key="index">
                                        <div class="control">
                                            <div class="field">
                                                <fg-input type="text"
                                                          v-bind:label="locales[index].locale"
                                                          v-model="locales[index].name"
                                                          placeholder="">
                                                </fg-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const moment = require('moment')
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    name: 'EditCategory',
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: null,
            locales: [],
        }
    },
    created: function () {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function () {
            window.history.back();
        },
        get: function (id) {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/images-categories/${this.id}`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    let data = JSON.parse(JSON.stringify(response.data));

                    self.category = data.category;
                    self.locales = data.locales;

                    _.map(self.locales, (l) => {

                        let tModel = _.find(self.category.translations, (t) => t.locale === l.locale);
                        l.name = tModel ? tModel.name : "";
                    })

                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        save: function () {
            let self = this;

            let category = JSON.parse(JSON.stringify(this.category));

            category.translations = JSON.parse(JSON.stringify(this.locales));


            axios.post(
                `${this.$hostname}/admin/images-categories/${this.id}/update`,
                category,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    const notification = {
                        template: `<span><b>Категория была успешно обновлена</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-explore-2',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'info'
                        })

                    //self.$router.push('/images-categories');
                })
                .catch(function (error) {
                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },

    }
}

</script>
<style scoped>
.btn-save {
    width: 150px;
}

.col-md-4 {
    padding: 15px !important;
}

.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}

.btn-file {
    display: none;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.device1 {
    display: inline-block;
    /*width: 281px;*/
    /*height: 609px;*/
    width: 337px;
    height: 731px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 40px;
}

.device2 {
    display: inline-block;
    /*width: 310px;*/
    /*height: 552px;*/
    width: 372px;
    height: 662px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.device3 {
    display: inline-block;
    /*width: 384px;*/
    /*height: 640px;*/
    width: 461px;
    height: 614px;
    border: 3px solid #000;
    border-radius: 10px;
    margin-left: 50px;
}

.mt30 {
    margin-top: 30px;
}

#ajaxForm, #ajaxForm2 {
    position: relative;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ImagesCategory/Edit.vue